import { DELETE_SHELVES, LOAD_SHELVES, LOADING_SHELVES, RESTORE_SHELVES } from './shelfTraining.action';
import { StoreShelf } from '@whiz-cart/node-shared/models/shelf/storeShelf';
import _ from 'lodash';

interface ShelfState {
    overview: StoreShelf[];
    shelvesToRestore: StoreShelf[];
    isLoading: boolean;
}

type ShelfTrainingReducerParam =
    | {
          type: typeof LOADING_SHELVES;
          payload: undefined;
      }
    | {
          type: typeof LOAD_SHELVES;
          payload: StoreShelf[];
      }
    | {
          type: typeof DELETE_SHELVES;
          payload: string[];
          storeGuid: string;
      }
    | {
          type: typeof RESTORE_SHELVES;
          payload: string[];
      };

export default (
    state: ShelfState = {
        overview: [],
        shelvesToRestore: [],
        isLoading: false,
    },
    action: ShelfTrainingReducerParam,
): ShelfState => {
    switch (action.type) {
        case LOADING_SHELVES:
            return {
                ...state,
                isLoading: false,
            };
        case LOAD_SHELVES:
            return {
                ...state,
                overview: action.payload,
                isLoading: false,
            };
        case DELETE_SHELVES: {
            const overview = state.overview?.filter((s) => action.payload.indexOf(s.shelfGuid) === -1);
            const shelvesToRestore = state.overview
                ?.filter((s) => action.payload.indexOf(s.shelfGuid) !== -1)
                .map((s) => ({ ...s, storeGuid: action.storeGuid }))
                .concat(...state.shelvesToRestore);

            return {
                ...state,
                overview,
                shelvesToRestore,
                isLoading: false,
            };
        }
        case RESTORE_SHELVES: {
            const restore: StoreShelf[][] = [];
            for (const shelves of action.payload) {
                restore.push(state.shelvesToRestore.filter((s) => s.shelfGuid === shelves));
            }

            const result = _(state.overview)
                .concat(...restore)
                .orderBy('shelfGuid')
                .groupBy((value) => value.shelfId ?? value.shelfNo)
                .value();

            const allRestore = restore.flat();
            const newShelvesToRestore = state.shelvesToRestore.filter((shelf) => !allRestore.includes(shelf));

            const newOverview: StoreShelf[] = [];
            for (const i in result) {
                newOverview.push(result[i]![0]!);
            }

            return {
                ...state,
                overview: newOverview,
                shelvesToRestore: newShelvesToRestore,
                isLoading: false,
            };
        }
        default:
            return state;
    }
};
